<template>
  <div>
    <default class="dark:text-gray-100">
      <h1 class="text-2xl font-bold">Moduly</h1>

      <p class="mt-4 text-gray-500 dark:text-gray-300"
      >Moduly jsou základní stavební jednotkou aplikace. Každý modul má svůj vlastní stav, který je ukládán v
        databázi. Moduly mohou být propojeny s dalšími moduly a mohou být zobrazeny na různých místech aplikace.
      </p>

      <h2 class="text-xl font-semibold mt-4">Nainstalované moduly</h2>
      <div v-if="modules && modules.length > 0" class="grid grid-flow-col grid-cols-min gap-4 mt-4">
        <div v-for="module in findInstalledModules" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">

          <div class="flex justify-between">
            <h3 class="text-lg font-semibold">{{ module.name }}</h3>
            <flowbite-settings-modal
                btn-name="Nastavení" :name="module.name + '- nastavení'">
              <template v-slot:modal-content>
                <module-settings-form :module="module"/>
              </template>
            </flowbite-settings-modal>
          </div>
          <span v-for="type in module.type" class="text-gray-500 bg-gray-200 px-1 text-sm rounded mr-2">#{{ type }}</span>

          <p class=" mt-2 text-gray-500">{{ module.description }}</p>


          <div class="">


            <button v-if="!module.isActive" @click="enableModule(module.settingsId)"
                    class="mt-4 bg-primary-700 text-white text-sm px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-primary-600">
              Povolit
            </button>
            <button v-if="module.isActive" @click="disableModule(module.settingsId)"
                    class="mt-4 border-primary-700 text-primary-700 bg-transparent text-sm px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-primary-700 hover:text-white">
              Zakázat
            </button>

          </div>
        </div>
      </div>

      <h2 class="text-xl font-semibold mt-4">Dostupné moduly</h2>

      <div v-if="modules && modules.length > 0" class="grid grid-flow-col grid-cols-min gap-4 mt-4">
        <div v-for="module in findNotInstalledModules" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">

          <h3 class="text-lg font-semibold">{{ module.name }}</h3>
          <span v-for="type in module.type" class="text-gray-500 bg-gray-200 px-1 text-sm rounded mr-2">#{{ type }}</span>

          <p class=" mt-2 text-gray-500">{{ module.description }}</p>


          <button @click="installModule(module.name)"
                  class="mt-4 bg-primary-700 text-white px-2 py-1 rounded-lg">Nainstalovat
          </button>

        </div>
      </div>

    </default>
  </div>
</template>

<script>
import Default from "@/layouts/admin/default.vue";
import {useAppStore} from "@/stores/appStore";
import ModuleSettingsForm from "@/components/forms/moduleSettingsForm/moduleSettingsForm.vue";
import FlowbiteSettingsModal from "@/components/flowbiteDynamic/flowbiteSettingsModal.vue";

export default {
  name: "modules",
  components: {FlowbiteSettingsModal, ModuleSettingsForm, Default},
  data() {
    return {
      modules: [],
      appStore: useAppStore()
    }
  },
  computed: {
    findNotInstalledModules() {
      return this.modules.filter(module => !module.isInstalled);
    },
    findInstalledModules() {
      return this.modules.filter(module => module.isInstalled);
    },

  },
  methods: {
    /** find not installed modules
     *  which are not installed in the project has "installedAt" property undefined
     * */

    installModule(moduleName) {
      this.$modulesSettingsApi.installModule(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id, moduleName).then(response => {

        this.fetchModules();
      });
    },


    enableModule(settingsId) {
      this.$modulesSettingsApi.switchModule(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id, settingsId, true).then(response => {

        this.fetchModules();
      });
    },
    disableModule(settingsId) {
      this.$modulesSettingsApi.switchModule(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id, settingsId, false).then(response => {

        this.fetchModules();
      });
    },

    fetchModules() {
      this.$modulesSettingsApi.findAllModules(this.appStore.selectedProject.spaceId, this.appStore.selectedProject._id).then(response => {
        console.log(response.data);
        this.modules = response.data;
      }).catch(e=>{
        console.log(e);
      });
    },


  }, mounted() {

    /**
     * Fetch all modules from the server
     */
    this.fetchModules();

  }
}

</script>

<style scoped>

</style>